import { useContext } from 'react';
import { SupplyPointContext } from '@/features/supply-points/context/SupplyPointContext';

export function useSupplyPoint() {
  return useContext(SupplyPointContext);
}
